import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  loading: boolean = false;
  unsubscribe$: Subject<any> = new Subject();

  constructor(private loaderService: LoaderService, private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.loaderService.isLoading.pipe(takeUntil(this.unsubscribe$)).subscribe((v) => {
      this.loading = v;
      this.ref.detectChanges();
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
